import { combineReducers } from "@reduxjs/toolkit";
import wheelOfFortuneReducer from './wheel-of-fortune';

export const gamesReducer = combineReducers({
    wheelOfFortune: wheelOfFortuneReducer,
});